import { clientsApi } from '../../../../services/api/clients-api';
import { showErrorMessage } from '../../../messages';
import {
  WORK_ORDERS_CREATION_CLIENTS_CLIENT_SET,
  WORK_ORDERS_CREATION_CLIENTS_LOAD_SUCCESS,
} from '../action-types';
import { push } from 'react-router-redux';
import { baseRoutePath } from '../work-orders';

export function goToBuildingSelection() {
  return (dispatch) => {
    dispatch(push(baseRoutePath + '/building-selection'));
  };
}

export function loadClientsRequest() {
  return (dispatch) => {
    return clientsApi.getClients().then((response) => {
      if (response.ok) {
        dispatch(loadClientsSuccess(response.clients));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
    });
  };
}

export function loadClientsSuccess(clients) {
  return {
    type: WORK_ORDERS_CREATION_CLIENTS_LOAD_SUCCESS,
    payload: clients,
  };
}

export function setClient(clientId) {
  return {
    type: WORK_ORDERS_CREATION_CLIENTS_CLIENT_SET,
    payload: clientId,
  };
}



// WEBPACK FOOTER //
// ./src/actions/admin/work-orders/creation/clients.js